import type { ReactNode } from 'react';

import { Button } from '@/components/design-system/Button';
import { PlusOutlined } from '@ant-design/icons';

interface TableEmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: ReactNode;
}

export const TableEmptyState = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  actionIcon
}: TableEmptyStateProps) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-start gap-4 pt-[5%]">
      <div className="bg-background-100/65 flex size-18 items-center justify-center rounded-full">
        <span className="[&_svg]:text-typography-200 flex items-center justify-center [&_svg]:h-9 [&_svg]:w-9">
          {icon}
        </span>
      </div>
      <div className="flex flex-col items-center gap-1 text-center">
        <p className="text-typography-900 text-base">{title}</p>
        {description && <p className="text-typography-400 text-md max-w-sm">{description}</p>}
      </div>
      {actionLabel && onAction && (
        <Button type="button" variant="default" size="md" onClick={onAction}>
          {actionIcon ?? <PlusOutlined />}
          {actionLabel}
        </Button>
      )}
    </div>
  );
};
